const qualifiedEventItems = [
    {
        id: 1,
        value: 'unemployment'
    },
    {
        id: 2,
        value: 'leaveOfAbsence'
    },
    {
        id: 3,
        value: 'disability'
    },
    {
        id: 4,
        value: 'hospitalization'
    },
    {
        id: 5,
        value: 'nursingHomeStay'
    },
    {
        id: 6,
        value: 'lossOfLife'
    }
];
export default qualifiedEventItems;
